module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_EN-00-e678722fab9257c36549436d3d24e015.svg";